import { Navigate, useLocation } from "react-router-dom";

export default function RequireDealerAuth({ children }) {
  const token = localStorage.getItem("dealerToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/dealer/login" replace state={{ from: location }} />;
  }
  return children;
}
